import React from "react";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";

// A nested MUI dialog participates in the same focus/modal stack as the task.
// Closing it must never bubble into the task's close or row-edit handlers.
export default function TaskPhotoPreview({ src, onClose }) {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => setFailed(false), [src]);
  const titleId = React.useId();
  const close = (event) => {
    event?.stopPropagation();
    onClose();
  };
  return (
    <Dialog
      open={!!src}
      onClose={close}
      onClick={(event) => event.stopPropagation()}
      aria-labelledby={titleId}
      maxWidth="lg"
      PaperProps={{ sx: { bgcolor: "#0f172a", color: "white", width: "min(1000px, 92vw)", m: 2 } }}
    >
      <div className="flex items-center justify-between gap-4 p-3">
        <h2 id={titleId} className="text-sm font-semibold">Task photo</h2>
        <button type="button" autoFocus onClick={close} aria-label="Close photo preview" className="inline-flex h-11 w-11 items-center justify-center rounded hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
          <CloseIcon />
        </button>
      </div>
      {failed ? (
        <p role="status" className="p-6 text-center">This photo could not be loaded. Close the preview and try opening it again.</p>
      ) : src ? (
        <img src={src} alt="Task attachment enlarged" onError={() => setFailed(true)} className="block w-full object-contain" style={{ maxHeight: "75vh" }} />
      ) : null}
    </Dialog>
  );
}
